// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class ServiceAccessRequestsForReviewerResource extends Resource {
    basePath: string = 'services/requestsForReviewer/';

    objectPath: string = 'services/requestsForReviewer/{ident}/';
}
